var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[(!_vm.loadingPage)?_c('div',[_c('ManagementDetailsHeader',{attrs:{"info":_vm.userData}}),_c('router-view')],1):_c('div',{staticClass:"d-flex justify-content-center align-items-center w-100"},[_c('spinner-loading',{attrs:{"text":"Loading"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }